import { Workbox, messageSW } from 'workbox-window';
import { playLocalSound } from '../utils/play.local.sound';

const TAG = '[service-worker-registration]';
let serviceWorker: Workbox;

if (typeof window !== 'undefined' && 'serviceWorker' in navigator /*&& process.env.EXPO_PUBLIC_NODE_ENV === 'production'*/) {
  const swUrl = process.env.EXPO_PUBLIC_NODE_ENV === 'development' ? '/fcm-logic.js' : '/firebase-messaging-sw.js';
  serviceWorker = new Workbox(swUrl, { scope: '/' });

  // SAFE AGGRESSIVE RELOAD: When the new SW takes control, reload the page.
  serviceWorker.addEventListener('controlling', (event) => {
    if (event.isUpdate) {
      console.log(TAG, 'New service worker active. Reloading page...');
      // window.location.reload();
    }
  });

  serviceWorker.register();

  navigator.serviceWorker.addEventListener('message', async (event) => {
    const { data } = event;
    if (!data) return;

    // Note: token-refresh is handled in notification.handler.ts, but we keep this clean
    if (data.type === 'play-sound') {
      try {
        if (data.soundName) {
          playLocalSound(data.soundName.split('.')[0]);
        }
      } catch (e) {
        console.error(e);
      }
    }
  });
}

export class ServiceWorker {
  public static async getNotificationToken() {
    if (!serviceWorker) {
      return undefined;
    }
    return this.sendMessage('GET_TOKEN');
  }

  private static async getSW() {
    return navigator.serviceWorker.ready.then((service) => {
      return service.active || service.installing || service.waiting;
    });
  }

  private static async sendMessage(type: string, payload?: any) {
    return this.getSW().then((sw) => {
      // messageSW sends the message and waits for the response on event.ports[0]
      if (!sw) return null;
      return messageSW(sw, { type, payload }).then((response) => {
        return response;
      });
    });
  }

  public static async clearNotifications() {
    if (!serviceWorker) {
      console.warn(TAG, 'Service worker not registered');
      return false;
    }
    return this.sendMessage('CLEAR_NOTIFICATIONS');
  }

  public static async showLocalNotification(title: string, options: any) {
    if (!serviceWorker) {
      console.warn(TAG, 'Service worker not registered, cannot show notification');
      return false;
    }
    return this.sendMessage('SHOW_LOCAL_NOTIFICATION', { title, options });
  }
}
